@if (description()) {
    <span class="ap-textarea__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<ng-content select="ap-context-explanation"></ng-content>

@if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
}

<div class="ap-textarea" [ngClass]="{ 'has-scrollbar': hasScrollbar }">
    <label class="ap-textarea__wrapper" data-testid="wrapper">
        <span class="ap-textarea__label" [attr.id]="uniqueId + '-label'" data-testid="label">{{ label() }}</span>
        <textarea
            #textarea
            class="ap-textarea__textarea"
            data-testid="textarea"
            [apAutoGrow]="autoGrow()"
            [attr.rows]="rows()"
            [attr.autocomplete]="autocomplete() ? autocomplete() : 'off'"
            [disabled]="isDisabled ? isDisabled : null"
            [attr.aria-describedby]="ariaDescribedBy"
            [attr.maxlength]="maxlength() ? maxlength() : null"
            [attr.aria-invalid]="control ? control.invalid : null"
            [attr.readonly]="readonly() ? true : null"
            [attr.value]="valueDisplay"
            [(ngModel)]="valueDisplay"
            (input)="onInputChange($event)"
            (blur)="onBlur()"
        ></textarea>

        @if (maxCharacters()) {
            <span
                class="ap-textarea__character-count"
                data-testid="count"
                aria-hidden="true"
                [class.ap-textarea__character-count--invalid]="characterLimitExceeded"
                [class.show-counter]="showCounter"
                [class.limit-reached]="limitReached"
            >
                {{ charactersUsed.toString() }}/{{ maxCharacters() }}
            </span>
            <span class="ap-sr-only">
                {{ 'textarea.aria.maxCharacters.allowed' | apContent: { maxCharacters: maxCharacters().toString() } }}
            </span>
        }
    </label>
    @if (icon()) {
        <button
            class="ap-textarea__button"
            [attr.disabled]="isDisabled || readonly() ? true : null"
            [attr.aria-labelledby]="uniqueId + '-label'"
            (click)="handleIconClick($event)"
            data-testid="button"
        >
            <asn-icon [name]="icon()" [size]="'large'" [color]="isDisabled ? 'disabled' : 'inherit'" data-testid="icon"></asn-icon>
        </button>
    }
</div>

@if (helpTextPosition() === HelpTextPosition.BELOW && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
}

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}

@if (maxCharacters()) {
    <div class="ap-sr-only" aria-live="polite" aria-atomic="true" data-testid="aria-max-characters-wrapper">
        @if (!characterLimitExceeded) {
            <span data-bb="aria-max-characters-live">{{
                'textarea.aria.maxCharacters.left'
                    | apContent: { charactersUsed: charactersUsed.toString(), maxCharacters: maxCharacters().toString() }
            }}</span>
        }
        @if (characterLimitExceeded) {
            <span data-bb="aria-max-characters-error">{{
                'textarea.aria.maxCharacters.exceeded' | apContent: { maxCharacters: maxCharacters().toString() }
            }}</span>
        }
    </div>
}

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-textarea__help-text {{ above ? 'ap-textarea__help-text--above' : 'ap-textarea__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="uniqueId + '-help-text'"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
